// Validation for Tanzania employer statutory identifiers. These are tied to the
// EMPLOYER's country (the company files TZ statutory returns for every employee,
// including foreign nationals), so TZ formats apply — unlike a personal phone,
// which can be any country.
//
// Each validator accepts an empty string as "not provided" (the caller decides if
// a field is required); only a non-empty, malformed value is rejected.

const digitsOnly = (v: string) => (v || '').replace(/\D/g, '');

/** TRA TIN — 9 digits (commonly shown as 123-456-789). */
export const isValidTIN = (v: string): boolean => {
  const t = (v || '').trim();
  return t === '' || digitsOnly(t).length === 9;
};

/** NIDA National ID — 20 digits (separators allowed). Digits only: employee-
 *  service stores national_id as digits and refuses anything else, so accepting
 *  a passport/permit number here only queued a change that could never be
 *  approved (PROD 2026-10-22). Passport / permit numbers have their own fields. */
export const isValidNationalId = (v: string): boolean => {
  const t = (v || '').trim();
  if (t === '') return true;
  const compact = t.replace(/[\s.-]/g, '');
  return /^\d{20}$/.test(compact);
};

/** NSSF membership number — numeric, 6–15 digits. */
export const isValidNSSF = (v: string): boolean => {
  const t = (v || '').trim();
  if (t === '') return true;
  const d = digitsOnly(t);
  return d.length >= 6 && d.length <= 15 && /^\d+$/.test(t.replace(/[\s-]/g, ''));
};

export const TIN_HINT = 'TIN must be 9 digits (e.g. 123-456-789).';
export const NATIONAL_ID_HINT = 'National ID must be the 20-digit NIDA number. No NIDA number? Ask HR to record your passport or permit number instead.';
export const NSSF_HINT = 'NSSF number must be 6–15 digits.';
